import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { PaginationProps } from '@/lib/types';

export const DataTablePagination = ({
  canPreviousPage,
  canNextPage,
  onPreviousPage,
  onNextPage,
  itemsName = 'item',
  totalItems,
  currentItems,
  pageIndex,
  pageSize,
  showRange = true,
  pageSizeOptions,
  onPageSizeChange,
}: PaginationProps) => {
  // "26–50 of 360" when we know the window, else the legacy count form.
  const rangeStart = pageIndex !== undefined && pageSize ? pageIndex * pageSize + 1 : undefined;
  const rangeEnd = rangeStart !== undefined ? rangeStart + currentItems - 1 : undefined;
  // Only for a table that offers the choice (#6758), and always the house
  // Select — the same control the date range uses, never a bare dropdown.
  const showSizePicker = !!pageSizeOptions?.length && !!onPageSizeChange;

  return (
    <div className='flex items-center justify-between gap-3 py-4'>
      {/* The count reads left, where the eye starts. */}
      <span className='text-sm text-gray-500'>
        {showRange &&
          (rangeStart !== undefined
            ? `${rangeStart.toLocaleString()}–${rangeEnd!.toLocaleString()} of ${totalItems.toLocaleString()} ${itemsName}s`
            : `${currentItems} of ${totalItems} ${itemsName}(s)`)}
      </span>
      {/* How many rows, then which rows: one group of controls, not two. */}
      <div className='flex items-center gap-2'>
        {showSizePicker && (
          <Select value={String(pageSize)} onValueChange={(v) => onPageSizeChange!(Number(v))}>
            <SelectTrigger className='h-8 w-28 bg-white text-xs' aria-label={`${itemsName}s per page`}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {pageSizeOptions!.map((size) => (
                <SelectItem key={size} value={String(size)}>
                  {size} rows
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
        <Button variant='outline' size='sm' onClick={onPreviousPage} disabled={!canPreviousPage}>
          Previous
        </Button>
        <Button variant='outline' size='sm' onClick={onNextPage} disabled={!canNextPage}>
          Next
        </Button>
      </div>
    </div>
  );
};
